module.exports = __webpack_public_path__ + "static/media/menu-dot-icon.e7dc6a22.png";